import { stack as d3_stack } from 'd3-shape'
import { extent as d3_extent, max as d3_max, min as d3_min } from 'd3-array'
import { convertRowsToData } from '../utils/dataUtils'
import { isSexe, isHomes, isDones } from '@/utils/chart'

export default function PyramidChartDataController(rows, config) {
  let rowsMale = rows.filter(r => isSexe(r[0]) || isHomes(r[0])).map(r => [...r.slice(1)])
  let rowsFemale = rows.filter(r => isSexe(r[0]) || isDones(r[0])).map(r => [...r.slice(1)])
  if (rowsMale.length === 2) {
    rowsMale[0].unshift('id')
    rowsMale[1].unshift('XXX')
    rowsFemale[0].unshift('id')
    rowsFemale[1].unshift('XXX')
  }
  return {
    male: HalfPyramidDataController(rowsMale, config),
    female: HalfPyramidDataController(rowsFemale, config),
  }
}

function HalfPyramidDataController(rows, config = {}) {
  let headers = rows[0]
  let propperHeaders
  let dims

  propperHeaders = ['id', ...headers.slice(1)]
  dims = 2

  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], dims)

  //Sort data by mode
  if (config.dataSorting !== 'none') {
    data.sort((a, b) => {
      let aAddition = a.value.reduce((accumulator, current) => (accumulator += current.value), 0)
      let bAddition = b.value.reduce((accumulator, current) => (accumulator += current.value), 0)
      let diff = aAddition - bAddition
      return config.dataSorting === 'asc' ? diff : -diff
    })
  }

  let extent

  extent = [
    d3_min(data, d => d3_min(d.value, dd => dd.value)),
    d3_max(data, d => d3_max(d.value, dd => dd.value)),
  ]

  if (extent[0] > 0) extent[0] = 0
  let extentSize = Math.abs(extent[1] - extent[0])
  let getSafeValue = v => {
    return config.minBarHeight
      ? Math.sign(v || 1) * Math.max((extentSize * config.minBarHeight) / 100, Math.abs(v))
      : +v
  }

  let keys = data.reduce((res, d) => {
    d.value.forEach(dd => res.push(dd.id))
    return res
  }, [])
  keys = keys.filter((value, index, self) => self.indexOf(value) === index)

  let objArray = data.map(layer => {
    let res = { id: layer.id }
    layer.value.forEach(dd => {
      res[dd.id] = dd.value
    })
    return res
  })
  let stack = d3_stack()
    .value((d, key) => getSafeValue(d[key]))
    .keys(keys)

  let stacked = stack(objArray)
  let result = stacked.map(layer => {
    return {
      id: layer.key,
      index: layer.index,
      value: layer.map(dd => {
        return {
          id: dd.data.id,
          value: dd.data[layer.key],
          safeValue: getSafeValue(dd.data[layer.key]),
          y0: dd[0],
          y1: dd[1],
          layerIndex: layer.index,
          isLastLayer: keys.indexOf(layer.key) === keys.length - 1,
          isFirstLayer: keys.indexOf(layer.key) === 0,
          parentId: layer.key,
        }
      }),
    }
  })
  return result
}
